import { Check, X } from "lucide-react";

const classic = [
  "Fokus auf provisionsstarken Finanzprodukten",
  "Eingeschränkte Auswahl durch feste Partnerbanken",
  "Standardberatung ohne individuelle Strategie",
  "Wenig Know-how bei staatlichen Förderungen & Steuern",
  "Kaum breit gestreute ETF- und Investmentoptionen",
];

const finable = [
  "Steueroptimierte Altersvorsorge mit allen staatlichen Förderungen",
  "100 % digitale Finanzberatung – bundesweit & flexibel",
  "Unabhängige Beratung – keine Bankprodukte, kein Vertriebsdruck",
  "Volle Transparenz bei Kosten, Rendite und Provisionen",
  "Smarte ETF-Investments mit attraktiven Renditen",
];

export default function Comparison() {
  return (
    <section className="py-20 md:py-28 bg-background">
      <div className="container">
        <h2 className="text-center font-display text-3xl md:text-4xl lg:text-5xl font-bold text-primary text-balance max-w-3xl mx-auto reveal">
          FINABLE vs. klassische Finanzberatung – Dein direkter Vergleich
        </h2>

        <div className="mt-14 grid md:grid-cols-2 gap-5 max-w-5xl mx-auto items-stretch">
          {/* Classic */}
          <div className="reveal rounded-2xl border border-border bg-muted/40 p-8 flex flex-col">
            <div className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">
              Klassische Finanzberater
            </div>
            <ul className="mt-6 grid grid-rows-5 gap-5 flex-1">
              {classic.map((item) => (
                <li
                  key={item}
                  className="flex gap-3 text-muted-foreground text-base leading-relaxed items-start"
                >
                  <span className="mt-0.5 w-6 h-6 rounded-full bg-muted flex items-center justify-center shrink-0">
                    <X className="w-3.5 h-3.5" />
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* FINABLE */}
          <div className="reveal relative rounded-2xl bg-gradient-card-dark text-white p-8 shadow-elegant border border-accent/30 flex flex-col">
            <div className="absolute -top-3 right-6 px-3 py-1 rounded-full bg-gradient-accent text-accent-foreground text-xs font-bold uppercase tracking-wider shadow-glow">
              Empfohlen
            </div>
            <div className="text-sm font-semibold uppercase tracking-wider text-accent">FINABLE</div>
            <ul className="mt-6 grid grid-rows-5 gap-5 flex-1">
              {finable.map((item) => (
                <li key={item} className="flex gap-3 text-base leading-relaxed items-start">
                  <span className="mt-0.5 w-6 h-6 rounded-full bg-accent flex items-center justify-center shrink-0 shadow-glow">
                    <Check className="w-3.5 h-3.5 text-accent-foreground" />
                  </span>
                  <span className="text-white/90">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
